import l, { cloneElement as w } from "react";
import y from "../../../../_virtual/isNil.js";
import _ from "../../../../_virtual/isObject.js";
import S from "../../../../_virtual/isFunction.js";
import L from "../../../../_virtual/last.js";
import { Label as d } from "./Label.js";
import { Layer as x } from "../container/Layer.js";
import { filterProps as B, findAllByType as E } from "../util/ReactUtils.js";
import { getValueByDataKey as k } from "../util/ChartUtils.js";
function c(t) {
  "@babel/helpers - typeof";
  return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, c(t);
}
var W = ["valueAccessor"], I = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function T(t) {
  return V(t) || K(t) || D(t) || C();
}
function C() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function D(t, e) {
  if (t) {
    if (typeof t == "string") return b(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return b(t, e);
  }
}
function K(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function V(t) {
  if (Array.isArray(t)) return b(t);
}
function b(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function m() {
  return m = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, m.apply(this, arguments);
}
function v(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function g(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? v(Object(r), !0).forEach(function(n) {
      N(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : v(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function N(t, e, r) {
  return e = $(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function $(t) {
  var e = F(t, "string");
  return c(e) == "symbol" ? e : e + "";
}
function F(t, e) {
  if (c(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (c(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function O(t, e) {
  if (t == null) return {};
  var r = H(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      n = o[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function H(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var M = function(e) {
  return Array.isArray(e.value) ? L(e.value) : e.value;
};
function u(t) {
  var e = t.valueAccessor, r = e === void 0 ? M : e, n = O(t, W), i = n.data, o = n.dataKey, f = n.clockWise, s = n.id, h = n.textBreakAll, j = O(n, I);
  return !i || !i.length ? null : /* @__PURE__ */ l.createElement(x, {
    className: "recharts-label-list"
  }, i.map(function(a, p) {
    var A = y(o) ? r(a, p) : k(a && a.payload, o), P = y(s) ? {} : {
      id: "".concat(s, "-").concat(p)
    };
    return /* @__PURE__ */ l.createElement(d, m({}, B(a, !0), j, P, {
      parentViewBox: a.parentViewBox,
      value: A,
      textBreakAll: h,
      viewBox: d.parseViewBox(y(f) ? a : g(g({}, a), {}, {
        clockWise: f
      })),
      key: "label-".concat(p),
      index: p
    }));
  }));
}
u.displayName = "LabelList";
function R(t, e) {
  return t ? t === !0 ? /* @__PURE__ */ l.createElement(u, {
    key: "labelList-implicit",
    data: e
  }) : /* @__PURE__ */ l.isValidElement(t) || S(t) ? /* @__PURE__ */ l.createElement(u, {
    key: "labelList-implicit",
    data: e,
    content: t
  }) : _(t) ? /* @__PURE__ */ l.createElement(u, m({
    data: e
  }, t, {
    key: "labelList-implicit"
  })) : null : null;
}
function U(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var n = t.children, i = E(n, u).map(function(f, s) {
    return /* @__PURE__ */ w(f, {
      data: e,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return i;
  var o = R(t.label, e);
  return [o].concat(T(i));
}
u.renderCallByParent = U;
export {
  u as LabelList
};
